import React, { Fragment } from "react";
import { isEmpty, startCase } from "lodash";

import BetSlipSky from "./BetSlipSky";
import useSportsBookLogic from "../../useLogic/useSportbookLogic";
const SportbookSky = ({
  data,
  user,
  detail,
  profileData,
  setBetSlipObject,
  favouriteList,
  position,
  addToFavioute,
}) => {
  const {
    header,
    setHeader,
    selected,
    setSelected,
    active,
    setActive,
    handelChange,
    sportBookCheck,
    updatedData,
    parlyBet,
    parlay,
    betSlipObject,
    showBetDialog,
  } = useSportsBookLogic({
    data,
    user,
    detail,
    profileData,
    setBetSlipObject,
    favouriteList,
    position,
    addToFavioute,
  });

  return (
    <Fragment>
      <div
        id="sportsBookTab_2_4"
        className="special_bets-tab-wrap ps ps--theme_default"
        data-ps-id="34966687-5a0b-2d77-bd14-b361ae826955"
      >
        <ul className="special_bets-tab">
          {premiumCategoryArray?.map((res, index) => {
            return (
              <li
                className={header == res?.type ? "select" : ""}
                onClick={() => {
                  setHeader(res?.type);
                }}
              >
                <div className="special_bets-tab-a" id="tab_All">
                  {res?.name}
                </div>
              </li>
            );
          })}
        </ul>
      </div>

      {updatedData?.length > 0 ? (
        updatedData?.map((item, index) => {
          if (item?.sportsBookSelection?.length > 0) {
            let lockOuter =
              item?.apiSiteStatus == "SUSPENDED" || item?.marketStatus != 1;
            let animate = favouriteList?.includes(item.id);
            return (
              <div
                id="sportsBookMarket_2_4115102_832762052"
                className="bets-wrap sports-book"
              >
                <h4
                  onClick={() =>
                    setActive((prev) => {
                      if (prev.includes(index)) {
                        return prev?.filter((obj) => {
                          return obj != index;
                        });
                      } else {
                        return [...prev, index];
                      }
                    })
                  }
                >
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      addToFavioute(detail?.eventId, "SportBook", item?.id);
                    }}
                    id="multiMarketPin"
                    className={animate ? "pin-on" : "pin-off"}
                    title="Add to Multi Markets"
                  />
                  <span id="marketName" className="to-collapse">
                    {item?.marketName}
                  </span>
                  <div className="fancy_info-popup">
                    <dl>
                      <dt>Min / Max</dt>
                      <dd>100.00 / 10000.00</dd>
                    </dl>
                    <a className="close">Close</a>
                  </div>
                </h4>

                {active?.includes(index) &&
                  item?.sportsBookSelection?.map((res, id) => {
                    if (Number(res?.odds) > 0) {
                      let newPosition = "";
                      if (
                        showBetDialog &&
                        betSlipObject?.playType == "sportBook" &&
                        item?.id == selected
                      ) {
                        let backProfit =
                          (Number(betSlipObject?.odds) - 1) *
                          Number(betSlipObject?.bidPrice);
                        let backLoss = Number(betSlipObject?.bidPrice);
                        if (res?.id == betSlipObject?.object?.id) {
                          newPosition =
                            Math.abs(res?.position) > 0
                              ? Number(backProfit) + Number(res.position)
                              : Number(backProfit);
                        } else {
                          newPosition =
                            Math.abs(res?.position) > 0
                              ? Number(res?.position) - Number(backLoss)
                              : -Number(backLoss);
                        }
                      }
                      let activeClass =
                        betSlipObject?.teamName == res?.selectionName &&
                        betSlipObject?.odds == res?.odds &&
                        item?.marketName == betSlipObject?.item?.marketName &&
                        showBetDialog;
                      let conditionShowPositon = !isEmpty(
                        position?.find((res) => {
                          return (
                            res?.marketId ==
                            `${item?.betfairEventId}S${item?.id}`
                          );
                        })
                      );
                      let conditionPosition =
                        showBetDialog &&
                        betSlipObject?.playType == "sportBook" &&
                        item?.id == selected &&
                        Number(betSlipObject?.bidPrice) > 0
                          ? true
                          : false;
                      let lock =
                        res?.isActive != 1 ||
                        item?.apiSiteStatus == "SUSPENDED" ||
                        item?.marketStatus != 1;

                      let oldObject = item?.oldSportsBookSelection?.find(
                        (obj) => {
                          return obj?.id == res?.id;
                        }
                      );
                      return (
                        <Fragment>
                          <dl
                            onClick={(e) => {
                              if (!lock) {
                                handelChange(res?.odds, item, res, e);
                                setSelected(item?.id);
                              }
                            }}
                            id="sportsBookSelection_2_4115102_832762052_2175242285"
                            className="bets-selections"
                            style={{ display: "flex" }}
                          >
                            <dt className>
                              <h4 id="selectionName"> {res?.selectionName}</h4>
                              <ul>
                                {Math.abs(res?.position) > 0 && (
                                  <li
                                    id="before"
                                    className={
                                      res?.position > 0 ? "win" : "lose"
                                    }
                                  >
                                    {" "}
                                    {res?.position > 0
                                      ? Math.abs(res?.position).toFixed(2)
                                      : `( ${Math.abs(res?.position).toFixed(
                                          2
                                        )} )`}
                                  </li>
                                )}
                                {!isNaN(Math.abs(newPosition) > 0) &&
                                  conditionPosition && (
                                    <li
                                      id="after"
                                      className={`to-${
                                        newPosition > 0 ? "win" : "lose"
                                      } `}
                                    >
                                      {" "}
                                      {newPosition > 0
                                        ? Math.abs(newPosition).toFixed(2)
                                        : `( ${Math.abs(newPosition).toFixed(
                                            2
                                          )} )`}
                                    </li>
                                  )}
                              </ul>
                            </dt>
                            {lock && (
                              <dd
                                id="suspend"
                                className="suspend"
                                isactive={1}
                                status={1}
                              >
                                <p>Suspend</p>
                              </dd>
                            )}
                            <dd>
                              <div
                                id="back_1 "
                                className={`back-1 ${
                                  activeClass ? "select" : ""
                                } ${
                                  res?.odds != oldObject?.odds ? "spark" : ""
                                }`}
                                style={{
                                  width: "100%",
                                  fontWeight: "bold",
                                  padding: "1.6vw",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <span>{res?.odds}</span>
                              </div>
                            </dd>
                            <dd className="mode-land" />
                          </dl>{" "}
                          {showBetDialog &&
                            betSlipObject?.playType == "sportBook" &&
                            item?.id == selected &&
                            res?.id == betSlipObject?.object?.id && (
                              <BetSlipSky />
                            )}
                        </Fragment>
                      );
                    }
                  })}
              </div>
            );
          }
        })
      ) : (
        <div id="noGameWrap" className="bets-wrap">
          <p className="no-game">
            Premium {startCase(detail?.gameType)} market will be available after
            Event at In-Play
          </p>
        </div>
      )}
    </Fragment>
  );
};

export default SportbookSky;

const premiumCategoryArray = [
  { type: "all", name: "All" },
  { type: "Popular", name: "Popular" },
  { type: "Match", name: "Match" },
  { type: "Innings", name: "Innings" },
  { type: "Over", name: "Over" },
  { type: "Batsman", name: "Batsman" },
];
